<template>
  <div style="height: 100%;overflow: auto;">
    <!-- 活动标题 -->
    <div v-wechat-title="'使魔计划'"></div>
    <div style="width: 100%; height: 100%; background: #fff">
      <div>使魔计划 首页</div>
      <h2 style="margin-top: 100px">生成的新图片</h2>
      <img style="width: 100%" :src="shareImg" alt="">
    </div>
    <div class="canvas-container" style="position: absolute; z-index: -1">
      <div ref="el" class="canvas-element">
        <canvas id="canvas"></canvas>
        <div class="qrcode" id="qrcode" style="width: 160px;height:160px"></div>
      </div>
    </div>
  </div>

</template>
<script>
import { fabric } from 'fabric';
import { generateQRCode } from '@/utils/share';
import ShareImageBg from '@/assets/images/active/hjwq/mid-autumn/popup/invite_link_popup.png';

export default {
  name: 'demo',
  components: {},
  data () {
    return {
      shareImg: null
    };
  },
  created () {
  },
  mounted () {
    this.initCanvas()
  },
  computed: {},
  methods: {
    initCanvas() {
      // 生成二维码
      generateQRCode(document.getElementById('qrcode'), {
        text: "https://www.baidu.com",
        colorDark: '#ffddac',
        colorLight: '#835031'
      });
      const canvas = new fabric.Canvas('canvas', {
        width: 605,
        height: 798,
        backgroundColor: 'transparent'
      });
      // 设置背景图片
      canvas.setBackgroundImage(ShareImageBg, () => {
        canvas.renderAll();
        const qrcodeImage = document.getElementById('qrcode').querySelector('canvas').toDataURL('image/png');
        // 把二维码插入图片里面
        fabric.Image.fromURL(qrcodeImage, (img) => {
          canvas.add(new fabric.Group([img], { left: 213, top: 445 }));
          this.shareImg = canvas.toDataURL('image/png');
        });
      });
    },
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/servitor/demo/index/index.vue